import type { ReactNode } from 'react'

/**
 * One calm empty / error state used everywhere: soft round icon, one title line,
 * one hint line, and an optional single action. Colours come from theme tokens, so it follows light/dark.
 */
export function EmptyState({
  icon,
  title,
  hint,
  action,
  tone = 'default',
  compact = false,
}: {
  icon: ReactNode
  title: string
  hint?: string
  action?: ReactNode
  tone?: 'default' | 'error'
  compact?: boolean
}) {
  return (
    <div className={`empty-state${tone === 'error' ? ' is-error' : ''}${compact ? ' is-compact' : ''}`} role={tone === 'error' ? 'alert' : 'status'}>
      <span className="empty-state-icon" aria-hidden="true">{icon}</span>
      <strong className="empty-state-title">{title}</strong>
      {hint ? <span className="empty-state-hint">{hint}</span> : null}
      {action ? <div className="empty-state-action">{action}</div> : null}
    </div>
  )
}
